import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseSearchComponent } from 'src/app/system-common/base-search/base-search.component';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { DashboardService } from '../services/dashboard.service';
import { PageHeader } from 'src/app/models/common/page-header';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
@Component({
  selector: '',
  template: '',
})
export class PerformanceLandingPageHandler extends BaseSearchComponent<DashboardService> implements OnInit {
  chartComponents = [{ type: 'region' }, { type: 'agent' }, { type: 'product' }, { type: 'premium' }];
  public usedFor;
  public headerTitle;
  constructor(
    public service: DashboardService,
    public headerService: HeaderService,
    public router: Router,
    public route: ActivatedRoute,
    public settingService: SettingService
  ) {
    super(service, router);
    const mode = this.route.snapshot.routeConfig?.path;
    this.usedFor = mode === 'performance' ? 'brokerPerformance' : 'performance';
  }

  ngOnInit() {
    super.ngOnInit();
  }

  protected getPageHeader(): PageHeader {
    let header = new PageHeader();
    header.title = this.settingService.getLabelValue('performance');
    return header;
  }

  dropChart(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.chartComponents, event.previousIndex, event.currentIndex);
  }

  trackByChart(index: number, chart: any) {
    return chart.id || chart.label || index;
  }

  removeChart(chart: any) {
    this.chartComponents = this.chartComponents.filter((c) => c !== chart);
  }

  ngOnDestroy() {
    this.service.clear();
  }
}
